module.exports = __webpack_public_path__ + "img/markerIcon.15236318.svg";